package features.shifts.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object AssignShiftModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-lg z-[102] hidden shadow-2xl") {
                id = "assign-shift-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Assign Shift" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                p("mb-6 text-slate-400") {
                    id = "assign-context"
                    +"Assigning shift..."
                }
                
                div("grid grid-cols-2 gap-3 mb-6") {
                    id = "shift-options-container"
                    // Options generated dynamically
                }
                
                div("mb-6 p-4 bg-dark-900 rounded-xl border border-dark-700") {
                    label("block text-sm font-medium mb-3") { +"Or Custom Time" }
                    div("flex gap-3 items-center") {
                        input(type = InputType.time, classes = "bg-dark-800 border border-dark-700 rounded-lg p-2 text-white w-full") {
                            id = "custom-start"
                        }
                        span { +"-" }
                        input(type = InputType.time, classes = "bg-dark-800 border border-dark-700 rounded-lg p-2 text-white w-full") {
                            id = "custom-end"
                        }
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/20 transition") {
                        // onClickFunction = { clearShift() } // To be implemented
                         +"Clear"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-brand-cyan text-white hover:bg-brand-green transition") {
                        // onClickFunction = { saveShiftAssignment() } // To be implemented
                        +"Save"
                    }
                }
            }
        }
    }
}
